import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CurrentUser } from './currentUser.service';

@Injectable()
export class CanActivateApp implements CanActivate {
  constructor(private router: Router, private currentUser: CurrentUser) {}

  public canActivate(): boolean {
    if (!this.currentUser.getJwtToken()) {
      this.router.navigate(['/account/login']);
      return false;
    }
    return true;
  }
}
